import type { Dialog as PrimeDialog } from "primereact/dialog";
import { forwardRef } from "react";

import type { DialogProps } from "./types-dialog";
import { useDialog } from "./use-dialog";
import { DialogView } from "./view-dialog";

/** `Dialog` do Prime com os padrões do Figma; o visual (X, padding, máscara) é do tema e a largura do `size` é o `data-size` lido pelo tema. */
export const Dialog = forwardRef<PrimeDialog, DialogProps>(function Dialog(props, ref) {
  const viewModel = useDialog(props, ref);

  return <DialogView {...viewModel} />;
});
Dialog.displayName = "Dialog";
